/**
 * Skeleton do Estoque — header padrão + busca + chips de categoria + a lista
 * de cartões agrupados por conjunto.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-5xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      <div className="flex flex-col gap-4">
        {/* Busca + botão */}
        <div className="flex items-center gap-3">
          <div className="h-10 flex-1 rounded-lg bg-slate-200" />
          <div className="h-10 w-28 rounded-lg bg-slate-200" />
        </div>

        {/* Chips de categoria */}
        <div className="flex flex-wrap gap-2">
          {[16, 24, 20, 18].map((w, i) => (
            <div key={i} className={`h-6 w-${w} rounded-full bg-slate-100`} style={{ width: `${w * 4}px` }} />
          ))}
        </div>

        {/* Cartões de conjunto */}
        {[0, 1].map((g) => (
          <div key={g} className="space-y-2">
            <div className="h-3 w-32 rounded bg-slate-200" />
            <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
              {[0, 1, 2].map((r) => (
                <div key={r} className="flex items-center gap-3 border-b border-slate-100 p-3 last:border-0">
                  <div className="flex-1 space-y-1.5">
                    <div className="h-4 w-40 rounded bg-slate-200" />
                    <div className="h-3 w-24 rounded bg-slate-100" />
                  </div>
                  <div className="h-7 w-24 rounded-md bg-slate-100" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
